<template>
  <v-layout>
    <v-layout
      class="pa-4"
      column
    >
      <v-layout
        justify-space-between
        row
      >
        <v-flex class="header">
          <h1 class="title -tongue">
            Olá, <strong>{{username}}</strong>.
            Você tem {{this.statusesCards.all}} requerimento{{ applications.length !== 1 ? 's' : '' }}:
          </h1>
        </v-flex>

        <v-flex>
          <v-layout row justify-end align-center>
            <v-btn v-if="!isAdmin" color="primary" @click="newApplication()">
              <v-icon left>mdi-plus-circle-outline</v-icon>
              <span class="text">Novo Requerimento</span>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row justify-start class="mt-4">
        <v-layout align-center>
          <filter-cards
            @changeActive="toggleActive"
            :cards="cards"
          />

        </v-layout>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import FilterCards from '@/components/application/list/FilterCards';
import colors from 'vuetify/es5/util/colors';
import { isEqual, findIndex } from 'lodash';


export default {
  name: 'ApplicationsHeader',
  components: {
    FilterCards,
  },
  data() {
    return {
      username: JSON.parse(localStorage.getItem('user')).name,
    };
  },
  props: {
    activeStatus: {
      type: String,
      default: 'all',
    },
    applications: {
      type: Array,
      default: () => [],
    },
    statusesCards: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    newApplication() {
      this.$router.push('novo');
    },
    changeAllToInactive() {
      this.cards = this.cards.map(item => ({
        ...item,
        active: false,
      }));
    },
    toggleActive(card) {
      // this.changeAllToInactive();
      const newActiveItemIndex = findIndex(this.cards, ['title', card.title]);
      this.cards[newActiveItemIndex].active = true;
      this.$emit('activeStatusChanged', card.status);
    },
  },
  computed: {
    isAdmin() {
      return this.$router.currentRoute.meta.userAlias === 'admin';
    },
    cards() {
      return [
        {
          title: 'TODOS', status: 'all', amount: this.statusesCards.all, borderColor: colors.grey.base, backgroundColor: colors.grey.lighten2, active: isEqual(this.activeStatus, 'all'),
        },
        {
          title: 'A ENVIAR', status: 'waiting_to_be_sent', amount: this.statusesCards.waiting_to_be_sent, borderColor: colors.grey.darken2, backgroundColor: colors.grey.lighten2, active: isEqual(this.activeStatus, 'waiting_to_be_sent'),
        },
        {
          title: 'EM ANÁLISE', status: 'waiting_for_review', amount: this.statusesCards.waiting_for_review, borderColor: colors.amber.base, backgroundColor: colors.amber.lighten5, active: isEqual(this.activeStatus, 'waiting_for_review'),
        },
        {
          title: 'PENDENTE', status: 'pending', amount: this.statusesCards.pending, borderColor: colors.red.base, backgroundColor: colors.red.lighten5, active: isEqual(this.activeStatus, 'pending'),
        },
        {
          title: 'APROVADO', status: 'done', amount: this.statusesCards.done, borderColor: colors.green.base, backgroundColor: colors.green.lighten5, active: isEqual(this.activeStatus, 'done'),
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
  .header{
    margin-left: 40px;
  }

</style>
